const doc = [({"input":"h-120 p-r-8 p-t-12", "input__normal":"p-l-8", "input__icon_left":"p-l-64"})];
module.exports = doc.length <= 1 ? doc[0] : doc;